export const CalcTableType = {
  Standard: "Standard",
  SoftwareAssignment: "SoftwareAssignment",
};

export const CalcTableTypeDescription = {
  [CalcTableType.Standard]: "Standard",
  [CalcTableType.SoftwareAssignment]: "Software Assignment",
};

export const CalcTableTypeOptions = [
  { value: CalcTableType.Standard, text: "Display Standard Table" },
  {
    value: CalcTableType.SoftwareAssignment,
    text: "Display Software Assignment Table",
  },
];
